import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../AppContext';
import './index.scss';
import './offcanvas.scss';
import manager from '../../Manager';

function TableOfContent(){
    const {globalState, updateGlobalState} = useContext(AppContext);
    const {selectedIndex, slides, settings, values, progressData} = globalState;
    const [slidesProgressData, setSlideProgressData] = useState([]);

    const selectedSlide = slides[selectedIndex];

    const handleClick = async (toIndex) => {
        if (!manager.inEditor) {
            updateGlobalState('selectedIndex', toIndex);
            if (manager.options.onSlidePageCallback) {
                let onTocClick = await manager.runAsPromise(
                    manager.options.onSlidePageCallback,
                    toIndex,
                    {
                        'currentSlide': slides[toIndex],
                        'previousSlide': selectedSlide
                    },
                );

                if (typeof onTocClick?.slidesDataProgress !== 'undefined') {
                    updateGlobalState('progressData', {"slidesProgressData": onTocClick.slidesDataProgress });
                }
            }
        }
    }

    useEffect(()=> {
        if (Object.keys(progressData).length !== 0 && progressData.constructor === Object) {
            // set current slide active by progress
            let progressPageCurrentIndex = progressData.progressPageCurrentIndex;
            let currentProgressPageSlideId = progressData.currentProgressPageSlideId;
            if (typeof progressPageCurrentIndex != 'undefined') {
                if (slides.length >= progressPageCurrentIndex) {
                    progressPageCurrentIndex = 0;
                }
                updateGlobalState('selectedIndex', parseInt(progressPageCurrentIndex??0));
            }

            if (typeof currentProgressPageSlideId != 'undefined' && currentProgressPageSlideId !== null && currentProgressPageSlideId !== '') {
                let slideIndexById = slides.findIndex(item => item.id === currentProgressPageSlideId);
                if (slideIndexById !== -1) {
                    updateGlobalState('selectedIndex', slideIndexById);
                }
            }

            if(typeof progressData.slidesProgressData !== 'undefined' && progressData.slidesProgressData !== null && progressData.slidesProgressData.length > 0) {
                setSlideProgressData(progressData.slidesProgressData);
            } else {
                setSlideProgressData([]);
            }
        }
    }, [progressData]);

    return (
        <div>
            <div className="offcanvas offcanvas-start tbtoc" id="tbcourse-table-of-content" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="-1" aria-labelledby="tableOfContent">
                <div className="offcanvas-header">
                    <h5 className="offcanvas-title" id="tableOfContent">Table of contents</h5>
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body pe-0">
                    <div className='tbtoc-container'>
                        <ul className="nav flex-column">
                            {slides?.map((slide, k) => {
                                // console.log(slidesProgressData);
                                let label = slide.template.type() === 'MultipleChoiceTemplate' ? slide.data?.esay : slide.name;
                                if (label.length === 0 ) {
                                    label = slide.name;
                                }
                                let numbering = k+1;

                                // set is slide is checked or not
                                let classChecked = slidesProgressData.some(item => item.id === slide.id) ? 'checked' : '';
                                return (
                                    // <li className={`nav-link ` + (k === selectedIndex ? 'active ' : '') + (k <= 3 ? 'checked ':'')} key={k}>
                                    <li className={`nav-link ` + (k === selectedIndex ? 'active ' : '') + classChecked} key={k}>
                                        <a role='button' onClick={() => handleClick(k)}>{numbering}. {label} </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default TableOfContent;